import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { UseFormReturn } from "react-hook-form";

interface ExpenseBasicFieldsProps {
  form: UseFormReturn<any>;
}

export const ExpenseBasicFields = ({ form }: ExpenseBasicFieldsProps) => {
  const expenseCategories = [
    { value: "Charges d'exploitation", label: "Charges d'exploitation" },
    { value: "Charges financières", label: "Charges financières" },
    { value: "Charges exceptionnelles", label: "Charges exceptionnelles" },
    { value: "Impôts et taxes", label: "Impôts et taxes" }
  ];

  const expenseSubcategories = {
    "Charges d'exploitation": [
      { value: "purchases", label: "Achats" },
      { value: "salaries", label: "Salaires" },
      { value: "rent", label: "Loyer" },
      { value: "transport", label: "Transport" },
      { value: "marketing", label: "Marketing" },
      { value: "subscriptions", label: "Abonnements" }
    ],
    "Charges financières": [
      { value: "loan_interest", label: "Intérêts d'emprunt" },
      { value: "bank_fees", label: "Frais bancaires" }
    ],
    "Charges exceptionnelles": [
      { value: "penalties", label: "Pénalités" },
      { value: "bad_debts", label: "Créances irrécouvrables" }
    ],
    "Impôts et taxes": [
      { value: "income_tax", label: "Impôt sur les bénéfices" },
      { value: "other_taxes", label: "Autres taxes" }
    ]
  };

  const selectedCategory = form.watch("expenseCategory");

  return (
    <>
      <FormField
        control={form.control}
        name="name"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Nom de la dépense</FormLabel>
            <FormControl>
              <Input
                placeholder="Nom de la dépense..."
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="amount"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Montant</FormLabel>
            <FormControl>
              <Input
                type="number"
                placeholder="0"
                {...field}
                onChange={(e) => field.onChange(parseFloat(e.target.value))}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="expenseCategory"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Catégorie de dépense</FormLabel>
            <Select onValueChange={field.onChange} defaultValue={field.value}>
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder="Sélectionnez une catégorie" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                {expenseCategories.map((category) => (
                  <SelectItem key={category.value} value={category.value}>
                    {category.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />

      {selectedCategory && (
        <FormField
          control={form.control}
          name="expenseSubcategory"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Sous-catégorie</FormLabel>
              <Select onValueChange={field.onChange} defaultValue={field.value}>
                <FormControl>
                  <SelectTrigger>
                    <SelectValue placeholder="Sélectionnez une sous-catégorie" />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  {expenseSubcategories[selectedCategory]?.map((subcategory) => (
                    <SelectItem key={subcategory.value} value={subcategory.value}>
                      {subcategory.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
              <FormMessage />
            </FormItem>
          )}
        />
      )}

      <FormField
        control={form.control}
        name="notes"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Notes</FormLabel>
            <FormControl>
              <Textarea placeholder="Détails de la dépense..." {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
};